import type { CollapseProps as _CollapseProps } from "@chakra-ui/react";
import { forwardRef, Collapse as _Collapse } from "@chakra-ui/react";

export interface CollapseProps extends _CollapseProps {}

export const Collapse = forwardRef<CollapseProps, "div">(({ ...props }, ref) => (
    <_Collapse ref={ref} {...props} />
));
